import { formatToSimpleDateTimeString } from '../../../FrontEndReact/src/Core/Utils/dateUtils';
import { getLoggedInUser as getLoggedInUserLegacy } from './legacy';
import { User } from '../../../FrontEndReact/src/Core/Types/user';
import { getToken } from '../../../FrontEndReact/src/Core/Services/common';

declare global {
	interface Window {
		portalId: number;
		portalAlias: string;
		siteRootPath: string;
		portalUploadPath: string;
		currentCultureId: number;
		cultureCode: string;

		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		portalSettings: any;
	}
}

export type UploadFile = {
	file: File;
	fields?: Record<string, string>;
};

export async function callBizpart<T>(
	subPath: string,
	postData?: object | number | boolean | UploadFile,
	method?: 'GET' | 'POST' | 'DELETE',
	noReturnData: boolean = false
): Promise<T | undefined> {
	const token = getToken();
	const url = getSiteRootPath() + subPath;

	const headers = {
		'Biz-Origin': 'bizreact',
	};
	if (token) {
		headers['Auth-Token'] = token;
	}

	const isUploadFile = () => {
		return postData && typeof postData === 'object' && postData['file'] instanceof File;
	};

	let isFile = false;
	const getFixedPostData = () => {
		if (typeof postData === 'number' || typeof postData === 'boolean') {
			return undefined;
		} else if (postData instanceof File || isUploadFile()) {
			isFile = true;
			return undefined;
		} else if (Array.isArray(postData)) {
			return undefined;
		} else if (postData) {
			return { ...postData };
		} else {
			return undefined;
		}
	};

	const fixedPostData = getFixedPostData();

	const dateProps: string[] = [];
	if (!isFile && (fixedPostData || postData)) {
		headers['Content-Type'] = 'application/json';

		if (fixedPostData) {
			fixDateProps(fixedPostData);
		}
	}

	function fixDateProps(o: object) {
		for (const p in o) {
			if (o[p] instanceof Date) {
				dateProps.push(p);
				o[p] = formatToSimpleDateTimeString(o[p]);
			} else if (typeof o[p] === 'object') {
				fixDateProps(o[p]);
			}
		}
	}

	if (!method) {
		if (fixedPostData ?? postData) {
			method = 'POST';
		} else {
			method = 'GET';
		}
	}

	const getBody = () => {
		if (postData instanceof File) {
			const formData = new FormData();
			formData.append('file', postData);
			return formData;
		} else if (isUploadFile()) {
			const uFile = postData as UploadFile;
			const formData = new FormData();
			formData.append('file', uFile.file);
			if (uFile.fields) {
				for (const [key, value] of Object.entries(uFile.fields)) {
					formData.append(key, value);
				}
			}
			return formData;
		} else {
			return fixedPostData ?? postData ? JSON.stringify(fixedPostData ?? postData) : undefined;
		}
	};

	const response = await fetch(url, {
		method,
		headers,
		body: getBody(),
	});

	if (method === 'DELETE' || noReturnData) return;

	const data: T = await response.json();
	if (data) {
		//transformDateStringPropsToDate not working as needed.
		// const dateFixed = transformDateStringPropsToDate<T>(data);
		//console.log("callBizpart data", data);
		for (const p of dateProps) {
			data[p] = new Date(data[p]);
		}
	}

	return data;
}

export function getLocalStorage(key: string) {
	const settingKey = `${key}_${getPortalId()}`;
	return localStorage.getItem(settingKey);
}

export function setLocalStorage(key: string, value: string) {
	const settingKey = `${key}_${getPortalId()}`;
	localStorage.setItem(settingKey, value);
}

function getSiteRootPath() {
	return window.siteRootPath;
}

function getPortalUploadPath() {
	return window.portalUploadPath;
}

export function getPathWSiteRoot(path: string): string {
	if (!path) {
		return path;
	}

	//todo cdn support and webp stuff

	const lPath = path.toLowerCase();
	if (lPath.startsWith('http')) {
		return path;
	}

	const portalUploadPath = getPortalUploadPath();
	const fullPath = path.replace('##UPLOAD##/', portalUploadPath);

	const portalAlias = getPortalAlias();
	const override = getLocalStorage(`override_siteroot_${portalAlias}`.toLowerCase());
	if (portalAlias.length > 0 && (override?.length ?? 0) > 0) {
		if (lPath.indexOf('getfilehandler.ashx') >= 0) {
			return `${override}${fullPath.replace('~/', '')}`;
		}
	}

	const siteRootPath = getSiteRootPath();
	if (fullPath.substring(0, siteRootPath.length) === siteRootPath) {
		return fullPath;
	} else if (fullPath.substring(0, 1) === '/') {
		return `${siteRootPath}${fullPath.replace('/', '')}`;
	} else {
		return `${siteRootPath}${fullPath.replace('~/', '')}`;
	}
}

function getPortalId() {
	return Number(window.portalId);
}

export function getPortalAlias() {
	return window.portalAlias;
}

export function getCurrentCultureId() {
	return Number(window.currentCultureId);
}

export function getCultureCode() {
	return window.cultureCode;
}

export function getLoggedInUser(): User {
	return getLoggedInUserLegacy();
}
